import React from 'react';
import { Component } from "react";
import './Nav.css';

class Nav extends Component{
  render () {
    return <span></span>
  }
}

export default Nav;
